<span class="ap-icon-button-link">
    <button class="ap-icon-button-link__button" (click)="onClick.emit($event)" data-testid="button">
        <ap-icon class="ap-icon-button-link__icon" [name]="iconName()" [size]="iconSize()"></ap-icon>
        <ng-content></ng-content>
    </button>
</span>
